<div class="fix-height" (resized)="debouncedOnResize($event)" >
    <classy-layout class="w-full bg-transparent"></classy-layout>
</div>
